import type { ChromeContent } from "../types";

// Source-language copy, lifted verbatim from the components it is moving out of
// (Header.tsx, Footer.tsx, nav.ts). Nothing is reworded here: the English render
// must stay byte-identical across this refactor, so a copy improvement and a
// locale extraction never land in the same diff.
export const chrome: ChromeContent = {
  nav: {
    labels: {
      "/": "Home",
      "/how-it-works": "How It Works",
      "/platforms": "Platforms",
      "/tradable-assets": "Tradable Assets",
      "/support": "Support",
    },
    ariaPrimary: "Primary",
    ariaMobile: "Mobile primary",
    ariaLegal: "Legal",
    openMenu: "Open menu",
    closeMenu: "Close menu",
  },

  cta: {
    signIn: "Sign in",
    getFunded: "Get Funded",
  },

  legal: {
    privacy: "Privacy Policy",
    terms: "Terms and Conditions",
    termsCompact: "Terms & Conditions",
  },

  notFound: {
    title: "Page not found | Flex Fund",
    description: "That page does not exist. Head back to the Flex Fund home page.",
    heading: "This page doesn't exist.",
    body: "The link may be out of date, or the address mistyped. Everything else is where you left it.",
    backHome: "Back to home",
  },

  footer: {
    tagline:
      "Capital. Raw spreads. Industry-leading splits. Built by traders, for traders.",
    ariaSocial: "Social links",
    sections: {
      product: "Product",
      company: "Company",
      legal: "Legal",
    },
    riskWarningLabel: "Risk warning.",
    riskWarningBody:
      "Trading leveraged instruments involves substantial risk and may not be suitable for everyone. Past performance is not indicative of future results.",
    rightsReserved: "ALL RIGHTS RESERVED",
  },
};
